<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                @if (error) {
                  <pr-color-panel [display]="'danger'">
                    <pr-panel-body clazz="pam">
                      <pr-label [name]="'error'" [width]="18" [height]="18">{{
                        error?.message
                      }}</pr-label>
                    </pr-panel-body>
                  </pr-color-panel>
                }
                @if (displayInitialFees) {
                  <div class="col col-md-12">
                    <pr-input-column
                      label="Frais appliqués à la souscription pour le versement initial"
                      [derrors]="derrors"
                    >
                      <input
                        formControlName="initialPaymentFeesPercent"
                        type="number"
                        min="{{ minInitialFees }}"
                        max="{{ maxInitialFees }}"
                        fraction="2"
                      />
                      <i>%</i>
                    </pr-input-column>
                  </div>
                }
                <ng-container>
                  <div class="col col-md-12">
                    <pr-input-column
                      label="Frais de dossier"
                      [derrors]="derrors"
                      [suffix]="'€'"
                    >
                      <input
                        formControlName="folderFeesAmount"
                        type="text"
                        placeholder="200"
                      />
                    </pr-input-column>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
